var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper"},[(!_vm.clickArea)?_c('div',{staticClass:"map-chart",attrs:{"id":"map-chart"}}):_c('Map',{attrs:{"districtCode":_vm.districtCode},on:{"getDataByQuery":_vm.getDataByQuery,"goBack":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }